function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { AnalyticsConnector } from '@amplitude/analytics-connector';
import { Poller } from '@amplitude/experiment-core';
import { NativeModules } from 'react-native';
import { isNative } from '../util/platform';
import { ConnectorUserProvider } from './connector';
export class DefaultUserProvider {
  constructor() {
    let baseProvider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _defineProperty(this, "baseProvider", void 0);

    _defineProperty(this, "nativeModule", NativeModules.ExperimentReactNativeClient);

    _defineProperty(this, "applicationContext", void 0);

    _defineProperty(this, "cachedUser", void 0);

    _defineProperty(this, "cachedApplicationContext", void 0);

    _defineProperty(this, "poller", new Poller(() => this.load(), 1000));

    this.baseProvider = baseProvider;
    this.applicationContext = AnalyticsConnector.getInstance('context').applicationContextProvider.getApplicationContext();
    this.load();
    this.poller.start();
  }
  /**
   * The variant method is not async
   */


  async load() {
    this.cachedUser = await this.getUser();
  }

  async getApplicationContext() {
    if (this.cachedApplicationContext) {
      return this.cachedApplicationContext;
    } else if (isNative()) {
      var _this$nativeModule;

      this.cachedApplicationContext = await ((_this$nativeModule = this.nativeModule) === null || _this$nativeModule === void 0 ? void 0 : _this$nativeModule.getApplicationContext());
      return this.cachedApplicationContext;
    } else {
      this.cachedApplicationContext = this.applicationContext;
      return this.cachedApplicationContext;
    }
  }

  getUserSync() {
    const context = this.cachedApplicationContext;
    let user;

    if (this.baseProvider instanceof ConnectorUserProvider) {
      const connectorProvider = this.baseProvider;
      user = connectorProvider.getUserSync();
    } else {
      user = this.cachedUser;
    }

    return { ...context,
      ...user
    };
  }

  async getUser() {
    var _this$baseProvider;

    const context = await this.getApplicationContext();
    const baseUser = await ((_this$baseProvider = this.baseProvider) === null || _this$baseProvider === void 0 ? void 0 : _this$baseProvider.getUser());
    return { ...context,
      ...baseUser
    };
  }

}
//# sourceMappingURL=default.js.map